import React from 'react'
import get from 'lodash/get'
import { graphql } from 'gatsby'

import ContentfulPage from '../../components/Page/ContentfulPage'
// import Timeline from '../../components/FI/Timeline'
// import TextureHeader from '../../components/TextureHeader'
import withContentfulBlocks from '../../components/withContentfulBlocks'

class AboutIndex extends React.Component {
  render () {
    return (
      <ContentfulPage
        blocks={this.props.blocks}
        siteName={get(this.props, 'data.site.siteMetadata.siteName')}
        pageTitle={`${get(this.props, 'data.site.siteMetadata.siteName')} / About`}
        pageUrl={`${get(this.props, 'data.site.siteMetadata.url')}/about`}
        pageDescription='Our mission – A new generation of access to care.'
      >
        {/* <TextureHeader headline='Company timeline' />
        <Timeline /> */}
      </ContentfulPage>
    )
  }
}

export default withContentfulBlocks(AboutIndex)

export const pageQuery = graphql`
  query FIAboutQuery {
    site {
      ...SiteMetaDataFragment
    }
    page: contentfulPage(contentful_id: { eq: "7lMbrureU3lCJaxrksUf33" }) {
      ...PageBlocksFragment
    }
  }
`
